import { render, staticRenderFns } from "./icons-wrapper.vue?vue&type=template&id=02434a58&scoped=true&"
import script from "./icons-wrapper.vue?vue&type=script&lang=ts&"
export * from "./icons-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./icons-wrapper.vue?vue&type=style&index=0&id=02434a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02434a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
